import { render, staticRenderFns } from "./Treaty.vue?vue&type=template&id=4ae6f46e&"
import script from "./Treaty.vue?vue&type=script&lang=js&"
export * from "./Treaty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports